import { TYPES as PICTURE_TYPES } from 'src/components/Elements/Picture';
import { Breakpoints } from 'src/components/HTKit/Grid';
import { immutableToJS } from 'src/utils/helpers';
import { MOBILE_AND_TABLET } from './constants';

/**
 * @typedef {{mediaType: 'image' | 'video', resolution: 'desktop' | 'mobile', original: string}} GalleryImage
 * @typedef {{attachments: GalleryImage[]}} GalleryItem
 * @typedef {GalleryItem[]} Gallery
 */

/**
 * @param {object} param0
 * @param {'DESKTOP' | 'MOBILE_AND_TABLET'} param0.type
 * @param {{}?} param0.sku
 * @returns {object}
 */
export const getImageSources = ({ type, sku }) => {
  if (!sku) return [];
  const showMdGrid = `(min-width: ${Breakpoints.MD_GRID}px)`;

  /**
   * @type {{heroImageUrl: string?, heroMobileImageUrl: string?, gallery?: Gallery}}
   */
  const skuJs = immutableToJS(sku);
  const { gallery } = skuJs;

  let productDesktopImage = '';
  const isProductSku = gallery && gallery.length;
  if (isProductSku) {
    /*
      - Product images are stored in sku.gallery and Service images are at (sku.heroImageUrl || sku.heroMobileImageUrl)
      - Service skus do not have sku.gallery, so we can assume if gallery is present then it is a product
    */

    /**
     * @type GalleryItem
     */
    const defaultGalleryItem = {
      attachments: [
        { resolution: 'desktop', original: '', mediaType: 'image' },
        { resolution: 'mobile', original: '', mediaType: 'image' },
      ],
    };
    const galleryItem =
      gallery.find((item) => item.attachments[0].mediaType === 'image') || defaultGalleryItem;

    productDesktopImage = galleryItem.attachments.find((set) => set.resolution === 'desktop')
      .original;
  }

  // Product mobile images are tiny and look bad on larger mobile devices, so let's use the desktop for all ranges
  const mobileImage = productDesktopImage || skuJs.heroMobileImageUrl;
  const desktopImage = productDesktopImage || skuJs.heroImageUrl;
  /*
    For desktop width we should load the image at mdGrid width because tablet uses the same image. If we set the media query to
    lgGrid then it will load the image every time it switches between mdGrid and lgGrid
  */
  if (type === MOBILE_AND_TABLET)
    return [
      {
        srcSet: desktopImage,
        type: PICTURE_TYPES.JPG,
        media: showMdGrid,
      },
      { srcSet: mobileImage, type: PICTURE_TYPES.JPG },
    ];
  return [
    {
      srcSet: desktopImage,
      type: PICTURE_TYPES.JPG,
      media: showMdGrid,
    },
  ];
};
